document.addEventListener('DOMContentLoaded', function() {
  let currencySymbol = '$';
  const getCurrencySymbol = () => {
    const checkoutBtn = document.querySelector('.totals__total-value');
    if (!checkoutBtn) return '$';

    const textContent = checkoutBtn.textContent?.trim();
    const getSymbol = (separator) => textContent?.split(separator)?.[1]?.trim()?.[0];

    return getSymbol('\n') || getSymbol(' ') || '$';
  };

  const getCartTotalAmount = () => {
    const total = document.querySelector('.totals__total-value');
    if (!total) return '$0.00';

    return total.textContent?.trim().split(' ')?.[0]?.trim() || '$0.00';
  }

  const updateTotalCartAmountLabel = () => {
    document.querySelector('#cart-drawer__total-amount-txt').textContent = `${getCartTotalAmount()}`;
  };

  const reloadCartItems = () =>
    fetch(`${window.location.origin}/cart.js`)
      .then((res) => res.json())
      .then((cart) => updateTotalCartAmountLabel(cart.total_price / 100));

  const updateCartItems = (data) =>
    fetch(`/cart/${data.quantity > 0 ? 'add.js' : 'change.js'}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }).then((response) => {
      if (!response.ok) throw new Error('Failed to add item to cart');
      return response.json();
    });

  const cartDrawerUpsellInit = (self) => {
    self.classList.add('loading-cart');
    const variantId = self.dataset.variantId;
    const quantity = parseInt(self.dataset.quantity || 1, 10);

    updateCartItems({ id: variantId, quantity })
      .then((data) => {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'upsell-item', cart: data });
        return debounce(updateTotalCartAmountLabel, 1000)();
      })
      .catch((error) => console.error('Error adding upsell item to cart:', error))
      .finally(() => self.classList.remove('loading-cart'));
  };

  const initClimateNeutralShippingProtection = (self) => {
    const toggleActiveState = (enabled) => self.classList.toggle('checked', enabled);
    const enabled = !self.classList.contains('checked');
    toggleActiveState(enabled);

    const shippingProtectionId = document.querySelector('#CartDrawer')?.dataset?.climateId?.trim();
    if (!shippingProtectionId) {
      toggleActiveState(false);
      return;
    }

    debounce(function (self, id, enabled) {
      self.classList.add('loading');
      updateCartItems({ id, quantity: enabled ? 1 : 0 })
        .then((data) => {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'shipping-protection-item', cart: data });
          return debounce(updateTotalCartAmountLabel, 1000)();
        })
        .catch(() => toggleActiveState(false))
        .finally(() => self.classList.remove('loading'));
    }, 100)(self, shippingProtectionId, enabled);
  };

  document.body.addEventListener('click', (event) => {
    currencySymbol = getCurrencySymbol();
    if (event.target && event.target.matches('.add-upsell-to-cart')) {
      debounce(cartDrawerUpsellInit, 500)(event.target);
    }
    if (event.target && event.target.matches('#add-climate-neutral-shipping-protection')) {
      initClimateNeutralShippingProtection(event.target);
    }
  });
});
